module.exports = __webpack_public_path__ + "img/mtf-info-icon.ad804af7.svg";